import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const coachingNotesState = (state: RootState) => state.scene.dashboard.coaching.notes;

export const getCoachingNotes = createSelector(coachingNotesState, ({ notes }) => notes);

export const isCoachingNotesLoading = createSelector(coachingNotesState, ({ loading }) => loading);

export const isCoachingNoteCreateLoading = createSelector(
  coachingNotesState,
  ({ createLoading }) => createLoading
);

export const getCoachingNotesDeleteLoadingIds = createSelector(
  coachingNotesState,
  ({ deleteLoadingIds }) => deleteLoadingIds
);

export const getCoachingNotesUpdateLoadingIds = createSelector(
  coachingNotesState,
  ({ updateLoadingIds }) => updateLoadingIds
);

export const getCoachingNotesError = createSelector(coachingNotesState, ({ error }) => error);

export const getCoachingNotesHasMore = createSelector(coachingNotesState, ({ hasMore }) => hasMore);

export const getCoachingNotesOffset = createSelector(coachingNotesState, ({ offset }) => offset);

export const getCoachingNotesRefreshCounter = createSelector(
  coachingNotesState,
  ({ refreshCounter }) => refreshCounter
);

export const getCategoryFilter = createSelector(
  coachingNotesState,
  ({ categoryFilter }) => categoryFilter
);

export const getPendingShareChartIds = createSelector(
  coachingNotesState,
  ({ pendingShareChartIds }) => pendingShareChartIds
);

export const getPendingShareEntities = createSelector(
  coachingNotesState,
  ({ pendingShareEntities }) => pendingShareEntities
);

export const getPendingShareMentions = createSelector(
  coachingNotesState,
  ({ pendingShareMentions }) => pendingShareMentions
);

export const getPendingShareNote = createSelector(
  coachingNotesState,
  ({ pendingShareNote }) => pendingShareNote
);

export const getRepliesByParent = createSelector(
  coachingNotesState,
  ({ repliesByParent }) => repliesByParent
);

export const getRepliesLoadingByParent = createSelector(
  coachingNotesState,
  ({ repliesLoadingByParent }) => repliesLoadingByParent
);

export const getRepliesErrorByParent = createSelector(
  coachingNotesState,
  ({ repliesErrorByParent }) => repliesErrorByParent
);

export const getRepliesCreatingByParent = createSelector(
  coachingNotesState,
  ({ repliesCreatingByParent }) => repliesCreatingByParent
);

export const getRepliesHasMoreByParent = createSelector(
  coachingNotesState,
  ({ repliesHasMoreByParent }) => repliesHasMoreByParent
);

export const getRepliesOffsetByParent = createSelector(
  coachingNotesState,
  ({ repliesOffsetByParent }) => repliesOffsetByParent
);
